import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AccountsList = Loadable(lazy(() => import("./AccountsList")));
const AccountAdd = Loadable(lazy(() => import("./AccountAdd")));

const AccountRoutes = [
  { path: "/account/manage-account", element: <AccountsList /> },
  { path: "/account/manage-account/:mode/:id", element: <AccountAdd /> },
  { path: "/account/manage-account/:mode", element: <AccountAdd /> },
];

export default AccountRoutes;
